import { render, staticRenderFns } from "./PoiContent.vue?vue&type=template&id=6a08c632"
import script from "./PoiContent.vue?vue&type=script&lang=js"
export * from "./PoiContent.vue?vue&type=script&lang=js"
import style0 from "./PoiContent.vue?vue&type=style&index=0&id=6a08c632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports